import React from 'react'
import Image from 'next/image'
import styles from './styles.module.scss' // Assuming you're using CSS Modules with Next.js

type Props = {
  className?: string
  data: any
}

function OfferComponent({ className, data }: Props) {
  return (
    <div className={`${styles.offerItem} ${className || ''}`.trim()}>
      <div className={styles.header}>
        <div className={styles.headerCont}>
          <div className={styles.logo}>
            <a rel='noopener noreferrer nofollow' href={data.affiliateLink}>
              <Image
                src={data.thumbnail.data.attributes.url}
                height={60}
                width={60}
                alt='logo'
              />
            </a>
          </div>
          <div className={styles.offer}>
            <span className={styles.duration}>{data.offerType}</span>
            <span className={styles.price}>{data.offer}</span>
          </div>
        </div>
        <div className={styles.rating}>
          <Image
            className={styles.image}
            src='/assets/icons/icon-star-green.svg'
            height={20}
            width={20}
            alt='check'
          />
          <p>{data?.ratings?.data[0]?.attributes?.score}</p>
        </div>
      </div>
      <a
        className={styles.button}
        href={data.affiliateLink}
        rel='noopener noreferrer nofollow'
      >
        {data.buttonText}
      </a>
    </div>
  )
}

export default OfferComponent
